const SuccessModal = ({
  show,
  onClose,
  title = "Thank You! 🎉",
  message = "Thanks for reaching out! We'll get back to you shortly.",
  buttonLabel = "Got it!",
}) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(15, 23, 42, 0.45)",
        backdropFilter: "blur(4px)",
        animation: "smFadeIn 0.25s ease",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "1.75rem",
          padding: "2.5rem 3rem",
          maxWidth: "420px",
          width: "90%",
          textAlign: "center",
          boxShadow:
            "0 25px 60px rgba(37, 99, 235, 0.18), 0 8px 24px rgba(0,0,0,0.10)",
          animation: "smPopIn 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close (×) button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "1rem",
            right: "1.25rem",
            background: "none",
            border: "none",
            fontSize: "1.25rem",
            cursor: "pointer",
            color: "#94a3b8",
            lineHeight: 1,
          }}
          aria-label="Close"
        >
          ✕
        </button>

        {/* Checkmark icon */}
        <div
          style={{
            width: "64px",
            height: "64px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 1.25rem",
            boxShadow: "0 8px 20px rgba(37, 99, 235, 0.35)",
          }}
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        {/* Title */}
        <h2
          style={{
            fontSize: "1.5rem",
            fontWeight: 800,
            color: "#0f172a",
            marginBottom: "0.5rem",
          }}
        >
          {title}
        </h2>

        {/* Message */}
        <p style={{ fontSize: "1rem", color: "#475569", lineHeight: 1.6 }}>
          {message}
        </p>

        {/* CTA button */}
        <button
          onClick={onClose}
          style={{
            marginTop: "1.75rem",
            background: "linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)",
            color: "#fff",
            border: "none",
            borderRadius: "0.875rem",
            padding: "0.75rem 2.25rem",
            fontWeight: 700,
            fontSize: "0.95rem",
            cursor: "pointer",
            boxShadow: "0 4px 14px rgba(37, 99, 235, 0.4)",
            transition: "opacity 0.2s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.opacity = "0.88")}
          onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
        >
          {buttonLabel}
        </button>
      </div>

      {/* Scoped keyframe animations */}
      <style>{`
        @keyframes smFadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        @keyframes smPopIn {
          from { opacity: 0; transform: scale(0.75); }
          to   { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default SuccessModal;
